import { defineRule } from 'vee-validate'
import { i18n } from '@/i18n.js'

defineRule('required_without_one', (value, [target], field) => {
  if (value && value.trim() !== '') {
    return true
  }
  if (target) {
    for (const val of target) {
      if (val && val.trim() !== '') {
        return true
      }
    }
  }
  // Currently can't get cross field name
  // https://github.com/logaretm/vee-validate/issues/4537
  return `${field.label} ${i18n.global.t('form.or')} ${getCrossFieldName(field.name)} ${i18n.global.t('form.required_without_one')}`
})

function getCrossFieldName(targetName) {
  switch (targetName) {
    case 'email':
      return i18n.global.t('form.mobile_phone')
    case 'mobile_phone-phone-number':
      return i18n.global.t('form.email')
    case 'home_phone-phone-number':
      return i18n.global.t('form.mobile_phone')
    default:
      break
  }
}
